import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';

const equalizerMotion = keyframes`
  from { transform: scaleY(0.35); }
  to { transform: scaleY(1); }
`;

const PlaybackEqualizer = ({ color = '#fff' }: { color?: string }) => (
  <Box aria-hidden="true" sx={{ display: 'flex', alignItems: 'center', gap: '2px', width: 23, height: 20 }}>
    {[460, 580, 420, 520, 640].map((duration, index) => (
      <Box key={duration} sx={{
        width: 3, height: 18, borderRadius: '2px', bgcolor: color,
        transform: `scaleY(${[0.4, 0.7, 1, 0.65, 0.35][index]})`,
        animation: `${equalizerMotion} ${duration}ms ease-in-out ${-index * 170}ms infinite alternate`,
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
      }} />
    ))}
  </Box>
);

export default PlaybackEqualizer;
